<script setup lang="ts">
import Layout from './components/Layout.vue'
</script>

<template>
    <Layout>
        <RouterView />
    </Layout>
</template>
